// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2hLyq","imageUploader":"EGiftCard_imageUploader__1ileF"};